// Mock data for Tidy commercial cleaning website

export const services = [
  {
    id: 'aviation',
    title: 'Aviation Services',
    description: 'Aircraft cleaning, private jet detailing and hangar services for FBOs, charter operators and corporate flight departments.',
    bg: '#e8a428',
    iconBg: '#e8a428',
    icon: 'Plane',
  },
  {
    id: 'commercial',
    title: 'Commercial Facilities',
    description: 'Recurring janitorial, day-porter and office cleaning programs for corporate, medical and professional spaces.',
    bg: '#ee8a5d',
    iconBg: '#ee8a5d',
    icon: 'Building2',
  },
  {
    id: 'industrial',
    title: 'Industrial & Warehouse',
    description: 'Heavy-duty warehouse, factory and manufacturing facility cleaning with OSHA-compliant crews and equipment.',
    bg: '#f4c5be',
    iconBg: '#f4c5be',
    icon: 'Factory',
  },
  {
    id: 'events',
    title: 'Events & Specialty',
    description: 'Pre-event, during, and post-event venue services, plus move-in/out, post-construction and one-time deep cleans.',
    bg: '#d6e4be',
    iconBg: '#d6e4be',
    icon: 'Sparkles',
  },
];

export const stats = [
  { value: '1,500', label: 'Facilities Cleaned' },
  { value: '320', label: 'Repeat Clients' },
  { value: '85', label: 'Trained Crew Members' },
];

export const howItWorks = [
  {
    step: '01',
    title: 'Tell us about your facility',
    description: 'Share the location, type of space and how often you need cleaning. Hangar, office or event venue \u2014 we cover it all.',
  },
  {
    step: '02',
    title: 'Get a tailored quote',
    description: 'Our team builds a custom scope and transparent quote within 24 hours. Approve it and we lock the date.',
  },
  {
    step: '03',
    title: 'Sit back. We make it shine.',
    description: 'Our uniformed crew arrives on time with all equipment and supplies. You get a spotless space, every time.',
  },
];

export const testimonials = [
  {
    quote: "Tidy detailed our fleet of three private jets ahead of a high-profile client trip. The cabins looked showroom-new and the team was discreet, fast and meticulous.",
    name: 'Daniel R.',
    location: 'Moore County Airport, Southern Pines NC',
  },
  {
    quote: "We switched our office cleaning to Tidy six months ago and have never looked back. Consistent, professional and our front desk no longer has to chase missed days.",
    name: 'Marisol G.',
    location: 'Pinehurst, NC',
  },
  {
    quote: "After a 600-guest gala at our venue, Tidy had the entire ballroom and kitchens ready for the next morning's brunch. Truly impressive operation.",
    name: 'Carlos M.',
    location: 'Raleigh, NC',
  },
  {
    quote: "Our manufacturing floor required deep cleaning between production cycles. The Tidy crew handled OSHA-compliant cleaning with zero downtime to our schedule.",
    name: 'Jenna L.',
    location: 'Sanford Industrial Park, NC',
  },
  {
    quote: "From the booking process to the final walk-through, Tidy is the most organized cleaning company we've ever worked with. They're now our exclusive vendor.",
    name: 'Patrick H.',
    location: 'Charlotte, NC',
  },
  {
    quote: "The hangar floor went from grease-stained to mirror finish. Our mechanics couldn't believe it. Tidy has earned all of our aviation work going forward.",
    name: 'Erika V.',
    location: 'Concord-Padgett Regional Airport, NC',
  },
];

export const whyUs = [
  {
    title: 'Vetted Crews',
    description: 'Every team member is background-checked, insured and trained on aviation-grade and industrial protocols.',
  },
  {
    title: 'One Facility Partner',
    description: 'From a single office to an entire fleet of aircraft — manage every cleaning and facility need with one accountable team.',
  },
  {
    title: '24/7 Response',
    description: 'Late-night events, early-morning departures, emergency spills, overnight industrial work. Our crews run around the clock.',
  },
];

export const blogPosts = [
  {
    category: 'Aviation',
    title: 'Why Cabin Cleanliness Defines the Private Aviation Experience',
    excerpt: 'Discerning passengers notice everything. A look at the details that separate ordinary aircraft cleaning from a true detailing service.',
    image: 'https://images.unsplash.com/photo-1636699811128-1a83547b76d5?w=600&q=80',
  },
  {
    category: 'Workplace',
    title: 'The Hidden ROI of a Professionally Cleaned Office',
    excerpt: 'Beyond appearances, a consistently clean workplace reduces sick days, lifts morale and impresses the clients who walk through your doors.',
    image: 'https://images.unsplash.com/photo-1580256081112-e49377338b7f?w=600&q=80',
  },
  {
    category: 'Events',
    title: 'How to Plan a Seamless Post-Event Clean-up at Scale',
    excerpt: 'Whether it\u2019s 50 guests or 5,000, the right crew plan turns a chaotic teardown into a quiet, efficient reset.',
    image: 'https://images.pexels.com/photos/6195125/pexels-photo-6195125.jpeg?auto=compress&w=600',
  },
];

export const partners = [
  'JetSet Aviation',
  'Skyline Hangars',
  'Atlas Logistics',
  'Coral Events Co.',
  'Brickell Tower Mgmt.',
  'Pinnacle Industrial',
];

export const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Service Areas', href: '#service-areas' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Insights', href: '#insights' },
];

export const heroImage = 'https://customer-assets.emergentagent.com/job_aviation-detail-hub/artifacts/epxufrjc_pexels-karola-g-5716747.jpg';
export const hangarImage = 'https://images.pexels.com/photos/20425755/pexels-photo-20425755.jpeg?auto=compress&w=1200';
export const teamImage = 'https://images.pexels.com/photos/6195125/pexels-photo-6195125.jpeg?auto=compress&w=1200';
export const industrialImage = 'https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce?w=1200&q=80';
